import client from './client';

export const getHseSettings = () =>
  client.get('/api/tenant-settings/hse').then(r => r.data);

export const updateHseSettings = (body) =>
  client.patch('/api/tenant-settings/hse', body).then(r => r.data);
